import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions } from '_api/types';

export const GET_PATIENT_DIAGNOSES = 'get-patient-diagnoses';

export const useGetPatientDiagnoses = () =>
  useGetQuery<ConstantsNameDescriptions<string>[]>(
    () => `/constant/diagnoses`,
    {},
    [GET_PATIENT_DIAGNOSES],
    {
      refetchOnWindowFocus: false,
    },
  );
